import React from 'react';

interface AuthButtonsProps {
  onOpenLogin: () => void;
  onOpenRegister: () => void;
}

export const AuthButtons: React.FC<AuthButtonsProps> = ({
  onOpenLogin,
  onOpenRegister,
}) => {
  return (
    <div className="flex items-center gap-1.5 sm:gap-2">
      <button
        type="button"
        onClick={onOpenLogin}
        className="px-2.5 sm:px-3 py-1.5 text-xs font-semibold text-slate-700 hover:text-indigo-600 transition cursor-pointer min-h-[44px] flex items-center justify-center"
      >
        Masuk
      </button>
      <button
        type="button"
        onClick={onOpenRegister}
        className="px-3 sm:px-3.5 py-1.5 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl text-xs font-semibold shadow-2xs transition cursor-pointer min-h-[44px] flex items-center justify-center"
      >
        Daftar
      </button>
    </div>
  );
};
